import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { warningSwal, SuccessSwal } from "Util/Toast";
import EarningClasses from "./Earning.module.css";
import Moment from "react-moment";
import { Services } from "Services";
import Skeleton from "react-loading-skeleton";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ConfirmationDiaolog } from "Util/Toast";
import Penalty from "../Penalty";
import { AccessControl } from "../../../../../Util/AccessControl";
import { AccessKeys } from "../../../../../Routes/config";
import ReactPaginate from "react-paginate";
import Generate from "./Adjustment";
import ModalLoad from "Components/loader/loader";
function Earnings() {
    const Navigate = useNavigate();
    const [manualAdjustment, setManualAdjustment] = useState(false);
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
        formState: { errors },
    } = useForm();
    const formData = watch();
    const [loading, setLoading] = useState(true);
    const [showPenalty, setShowPenalty] = useState(false);
    const [penaltyDetails, setPenaltyDetails] = useState({});
    const [outStanding, setOutStandings] = useState(0);
    const token = { Authorization: `token ${localStorage.getItem("token")}` };

    const [params] = useSearchParams();
    const [selectedRows, setSelectedRows] = useState([]);
    const [forcepage, setforcepage] = useState(0);
    const [adminData, setAdminData] = useState(
        JSON.parse(localStorage.getItem("admindata"))
    );
    const [offset, setOffset] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [selectAll, setSelectAll] = useState(false);
    let [Apibody, setBody] = useState({});
    const [earning, setEarning] = useState({
        AmountToCredit: 0,
        AmountToDebit: 0,
        Tutors_Earnings: [],
    });
    const get_Earnings = (body, offset) => {
        if (!loading) {
            setLoading(true);
        }
        Services.Get_Tutor_Earnings(
            "POST",
            JSON.stringify({ ...body, toSkip: offset }),
            token
        )
            .then((res) => {
                setLoading(false);
                if (res.Status === 1) {
                    setTotalCount(res?.EarningsCount / 20);
                    setOutStandings(res?.Tutor_Outstanding);
                    setEarning({
                        Tutors_Earnings: res.Tutors_Earnings,
                        AmountToDebit: res.AmountToDebit,
                        AmountToCredit: res.AmountToCredit,
                    });
                } else if (res.Status === 0) {
                    warningSwal("Error", res?.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                setLoading(false);
                // alert(err);
                warningSwal("Error", "Something went wrong ");
                console.log(err);
            });
    };
    useEffect(() => {
        let body = { TutorID: params.get("TutorId"), Type: "ALL" };
        setBody(body);
        get_Earnings(body, 0);
        setforcepage(0);
    }, []);
    const onSubmit = (data) => {
        if (data.FromDate > data.ToDate) {
            warningSwal("Warning", "From Date should be less than To Date");
            return false;
        }
        let body = {
            TutorID: params.get("TutorId"),
            Type: "DATE",
            ...data,
        };
        setBody({ TutorID: params.get("TutorId"), Type: "DATE", ...data });
        get_Earnings(body, 0);
        setforcepage(0);
        setLoading(true);
    };
    const toggleSelectAll = () => {
        setSelectAll(!selectAll);
        setSelectedRows(
            selectAll
                ? []
                : earning?.Tutors_Earnings?.map((row) => row.TutorEarningID)
        );
    };
    const toggleRowSelection = (rowId) => {
        if (selectedRows.includes(rowId)) {
            setSelectedRows(selectedRows.filter((id) => id !== rowId));
        } else {
            setSelectedRows([...selectedRows, rowId]);
        }
    };
    const PAYOUT_CALL = (props) => {
        setLoading(true);

        let body = {
            EarningsIds: selectedRows,
            TutorID: params.get("TutorId"),
            CreditedAmount: props.creditSum,
            DebitedAmount: props.debitSum,
            AmountToPay: props.creditSum - props.debitSum,
        };
        Services.Create_Payouts("POST", JSON.stringify(body), token)
            .then((res) => {
                setTimeout(() => {
                    setSelectAll(false);
                    setSelectedRows([]);
                    reset();
                    let data = { TutorID: params.get("TutorId"), Type: "ALL" };
                    setBody(data);
                    get_Earnings(data, 0);
                    setforcepage(0);
                }, 300);
                if (res.Status === 1) {
                    SuccessSwal("Successful", "Payout created successfully");
                } else if (res.Status === 0) {
                    warningSwal("Warning", res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                setLoading(false);
                // alert(err);
                warningSwal("Error", "Something went wrong ");
                console.log(err);
            });
    };
    const CreatePayoutHandler = () => {
        const selectedEarnings = earning?.Tutors_Earnings?.filter((earning) =>
            selectedRows.includes(earning.TutorEarningID)
        );

        // Initialize variables to store the sum of amounts for credit and debit
        let creditSum = 0;
        let debitSum = 0;

        // Iterate through the selected earnings
        selectedEarnings.forEach((earning) => {
            // Check the value of Credit_Or_Debit and accumulate the amount accordingly
            if (earning.Credit_Or_Debit === "CREDIT") {
                creditSum += earning.Amount;
            } else if (earning.Credit_Or_Debit === "DEBIT") {
                debitSum += earning.Amount;
            }
        });
        if (creditSum - debitSum < 0) {
            warningSwal("Warning", "Total Payout Amount cannot be negative");
            return;
        }
        ConfirmationDiaolog(
            "Are You sure you want to create Payout?",
            "Create Payout",
            PAYOUT_CALL,
            {
                debitSum,
                creditSum,
            }
        );
    };
    const checkPenalty = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let id = e.currentTarget.getAttribute("id");
        // id={TutorEarningID}
        let [earningData] = earning.Tutors_Earnings.filter(
            (item) => item.TutorEarningID == id
        );
        setPenaltyDetails(earningData);
        setShowPenalty(true);
    };
    const handlePageChange = (selectedObject) => {
        window.scrollTo({ top: 10, behavior: "instant" });
        setforcepage(selectedObject.selected);
        setLoading(true);
        setOffset(selectedObject.selected * 20);

        get_Earnings(Apibody, selectedObject.selected * 20);
    };
    const ClickHanlder = (id) => {
        if (id != 0) {
            Navigate(`/scheduledClasses/Details?scheduleID=${id}`);
        }
    };
    return (
        <div className={EarningClasses["Container"]}>
            {manualAdjustment && (
                <Generate
                    Transactions={() => {
                        get_Earnings(Apibody, 0);
                        setforcepage(0);
                    }}
                    setShowPaymentModal={setManualAdjustment}
                    showPaymentModal={manualAdjustment}
                    TutorId={params.get("TutorId")}
                />
            )}
            {showPenalty && (
                <Penalty
                    modal={showPenalty}
                    setModal={setShowPenalty}
                    getDetails={{
                        get_Earnings,
                        forcepage,
                        setforcepage,
                        Apibody,
                        offset,
                        penaltyDetails: penaltyDetails,
                        TutorID: params.get("TutorId"),
                        ToDate: formData.ToDate,
                        FromDate: formData.FromDate,
                        payoutDetails: false,
                    }}
                />
            )}
            <div className={EarningClasses["headi"]}>
                <h3>Earnings</h3>
                {(adminData.Type == 1 ||
                    adminData.Type == 6 ||
                    adminData.Type == 8 ||
                    adminData.Type == 11 ||
                    adminData.Role == 40) && (
                    <button onClick={() => setManualAdjustment(true)}>
                        Manual Adjustment
                    </button>
                )}
            </div>
            {/* <p>Filter By Date</p> */}
            <header>
                <form
                    className={EarningClasses["form"]}
                    onSubmit={handleSubmit(onSubmit)}>
                    <input
                        type="date"
                        max={new Date().toISOString().split("T")[0]}
                        {...register("FromDate", {
                            required: true,
                        })}
                    />
                    <input
                        type="date"
                        max={new Date().toISOString().split("T")[0]}
                        {...register("ToDate", {
                            required: true,
                        })}
                    />
                    <button>Filter</button>
                </form>
                <div>
                    <button
                        onClick={CreatePayoutHandler}
                        disabled={selectedRows.length == 0}
                        title={
                            selectedRows.length == 0
                                ? "Select Earnings to create Payout"
                                : ""
                        }>
                        Create Payout
                    </button>
                </div>
            </header>
            {/* //2,6,8,1 */}
            {(adminData.Type == 1 ||
                adminData.Type == 2 ||
                adminData.Type == 11 ||
                adminData.Type == 6 ||
                adminData.Type == 8 ||
                adminData.Role == 40) && (
                <div className={EarningClasses["outstanding"]}>
                    <h3>Total Outstandings :</h3>
                    <p>{outStanding}</p>
                </div>
            )}
            <div className={EarningClasses["Table"]}>
                <table>
                    <thead>
                        <tr>
                            {earning?.Tutors_Earnings?.length > 0 && (
                                <th>
                                    <input
                                        type="checkbox"
                                        checked={selectAll}
                                        onChange={toggleSelectAll}
                                    />
                                </th>
                            )}
                            <th>Class Date</th>
                            <th>Class Time</th>
                            <th>Duration</th>
                            <th>Batch Name</th>

                            <th>Type</th>
                            <th>Reason</th>
                            <th>Credit</th>
                            <th> Debit</th>
                            {/* <th>Created By</th> */}
                            <th>Status</th>
                            {AccessControl(AccessKeys.Tutor)?.edit === 1 && (
                                <th>Actions</th>
                            )}
                        </tr>
                    </thead>
                    {loading ? (
                        <tbody>
                            {[1, 1].map((item) => (
                                <tr className={EarningClasses["loading"]}>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    {/*  <td>
                                        <Skeleton />
                                    </td> */}
                                    <td>
                                        <Skeleton />
                                    </td>
                                    {AccessControl(AccessKeys.Tutor)?.edit ===
                                        1 && (
                                        <td>
                                            <Skeleton />
                                        </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        <tbody>
                            {earning?.Tutors_Earnings?.length > 0 ? (
                                earning?.Tutors_Earnings?.map((item) => {
                                    return (
                                        <tr>
                                            {" "}
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedRows.includes(
                                                        item.TutorEarningID
                                                    )}
                                                    onChange={() =>
                                                        toggleRowSelection(
                                                            item.TutorEarningID
                                                        )
                                                    }
                                                />
                                            </td>
                                            <td>
                                                {item.ClassDate && (
                                                    <Moment format="DD-MM-YYYY">
                                                        {
                                                            new Date(
                                                                item.ClassDate
                                                            )
                                                        }
                                                    </Moment>
                                                )}
                                            </td>
                                            <td>{item.ClassTime}</td>
                                            <td>
                                                {item.DurationInMinutes} Min
                                            </td>
                                            <td
                                                style={{
                                                    maxWidth: "12rem",
                                                    wordBreak: "break-word",
                                                }}
                                                onClick={() => {
                                                    if (
                                                        item.BatchName != "NA"
                                                    ) {
                                                        ClickHanlder(
                                                            item.ScheduleClassID
                                                        );
                                                    }
                                                }}>
                                                <span
                                                    style={{
                                                        textDecoration:
                                                            item.ScheduleClassID !=
                                                                0 &&
                                                            item.EarningType !=
                                                                "DemoConversion_Fee"
                                                                ? "underline"
                                                                : "none",
                                                    }}>
                                                    {item.BatchName}
                                                </span>
                                            </td>
                                            {/* //DemoConversion_Fee */}
                                            <td>
                                                {item.EarningType ==
                                                "Manual_balance_Adjustment"
                                                    ? "Manual Adjustment"
                                                    : item.EarningType ==
                                                          "DemoConversion_Fee" &&
                                                      String(
                                                          item.Credit_Or_Debit
                                                      ).toLowerCase() ===
                                                          "DEBIT".toLowerCase()
                                                    ? "Incorrect Charge – Demo Conversion"
                                                    : item.EarningType ==
                                                          "DemoConversion_Fee" &&
                                                      String(
                                                          item.Credit_Or_Debit
                                                      ).toLowerCase() ===
                                                          "CREDIT".toLowerCase()
                                                    ? "Demo Conversion"
                                                    : String(item.EarningType)
                                                          .split("_")
                                                          .join(" ")}
                                            </td>
                                            <td style={{ maxWidth: "15rem" }}>
                                                {item?.AdjustmentComment}{" "}
                                                {item?.Adjustment_Reason !=
                                                    "NA" &&
                                                    `(
                                                ${item.Adjustment_Reason})`}
                                            </td>
                                            <td
                                                style={{
                                                    color:
                                                        String(
                                                            item.Credit_Or_Debit
                                                        ).toLowerCase() ===
                                                        "DEBIT".toLowerCase()
                                                            ? "red"
                                                            : "green",
                                                }}>
                                                {item.Credit_Or_Debit != "DEBIT"
                                                    ? isNaN(item.Amount)
                                                        ? 0.0
                                                        : `₹ ${Number(
                                                              item.Amount
                                                          ).toFixed(2)}`
                                                    : "-"}
                                            </td>
                                            <td
                                                style={{
                                                    color:
                                                        String(
                                                            item.Credit_Or_Debit
                                                        ).toLowerCase() ===
                                                        "DEBIT".toLowerCase()
                                                            ? "red"
                                                            : "green",
                                                }}>
                                                {item.Credit_Or_Debit == "DEBIT"
                                                    ? isNaN(item.Amount)
                                                        ? 0.0
                                                        : `₹ ${Number(
                                                              item.Amount
                                                          ).toFixed(2)}`
                                                    : "-"}
                                            </td>
                                            {/*      <td style={{ width: "7rem" }}>
                                                {item.EarningCreatedByName}
                                            </td> */}
                                            <td>
                                                {item.IsPayoutCreated == 1 &&
                                                item.Credit_Debit_Status ===
                                                    1 ? (
                                                    <span
                                                        className={
                                                            EarningClasses[
                                                                "paid"
                                                            ]
                                                        }
                                                        style={{
                                                            backgroundColor:
                                                                item.Credit_Or_Debit ===
                                                                "DEBIT"
                                                                    ? "#EA4335"
                                                                    : "#34A853",
                                                        }}>
                                                        {item.Credit_Or_Debit ===
                                                        "DEBIT"
                                                            ? "Debit"
                                                            : "Credit"}
                                                    </span>
                                                ) : item.CanCreatePayout ==
                                                  0 ? (
                                                    <span
                                                        className={
                                                            EarningClasses[
                                                                "unpaid"
                                                            ]
                                                        }
                                                        style={{
                                                            backgroundColor:
                                                                "orange",
                                                        }}>
                                                        Reversed
                                                    </span>
                                                ) : (
                                                    <span
                                                        className={
                                                            EarningClasses[
                                                                "unpaid"
                                                            ]
                                                        }>
                                                        Pending
                                                    </span>
                                                )}
                                                {item.IsPayoutCreated == 0 && (
                                                    <p></p>
                                                )}
                                                <div
                                                    style={{
                                                        marginTop: "1rem",
                                                    }}>
                                                    {item.IsPenalityChallenged ===
                                                        1 && (
                                                        <span
                                                            className={
                                                                EarningClasses[
                                                                    "paid"
                                                                ]
                                                            }
                                                            style={{
                                                                backgroundColor:
                                                                    "#93e2a8",
                                                                borderColor:
                                                                    "transparent",
                                                            }}>
                                                            Challenge Accepted
                                                        </span>
                                                    )}
                                                    {item.IsPenalityChallenged ===
                                                        2 && (
                                                        <span
                                                            className={
                                                                EarningClasses[
                                                                    "pending"
                                                                ]
                                                            }
                                                            style={{
                                                                backgroundColor:
                                                                    "#94c5f3",
                                                            }}>
                                                            Penalty Challenged
                                                        </span>
                                                    )}
                                                    {item.IsPenalityChallenged ===
                                                        3 && (
                                                        <span
                                                            className={
                                                                EarningClasses[
                                                                    "pending"
                                                                ]
                                                            }
                                                            style={{
                                                                backgroundColor:
                                                                    "#faada7",
                                                            }}>
                                                            Challenge Rejected
                                                        </span>
                                                    )}
                                                </div>
                                            </td>
                                            {AccessControl(AccessKeys.Tutor)
                                                ?.edit === 1 && (
                                                <td>
                                                    {item.IsPenalityChallenged ===
                                                    2 ? (
                                                        <>
                                                            <button
                                                                id={
                                                                    item.TutorEarningID
                                                                }
                                                                onClick={
                                                                    checkPenalty
                                                                }
                                                                style={{
                                                                    padding:
                                                                        "0.5rem",
                                                                    border: "1px solid #ccc",
                                                                    backgroundColor:
                                                                        "white",
                                                                }}
                                                                disabled={
                                                                    item.isPayoutGenerated ==
                                                                    1
                                                                }>
                                                                View Penalty
                                                                Challenge
                                                            </button>
                                                        </>
                                                    ) : (
                                                        "NA"
                                                    )}
                                                </td>
                                            )}
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td
                                        colSpan={8}
                                        style={{ textAlign: "center" }}>
                                        No Record Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    )}
                </table>
            </div>
            <div
                style={{
                    justifySelf: "right",
                }}>
                <ReactPaginate
                    pageCount={totalCount}
                    marginPagesDisplayed={2}
                    forcePage={forcepage}
                    onPageChange={handlePageChange}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    containerClassName={"pagination"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    activeClassName={"active"}
                />
            </div>
        </div>
    );
}

export default Earnings;
